import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { GetEmailSuppressionResultsQuery } from '@/gql/graphql';
import emailKeys from './keyFactory';

const GET_EMAIL_SUPPRESSION_RESULTS = graphql(`
  query GetEmailSuppressionResults($emails: [String!]!) {
    emailSuppressionResults(emails: $emails) {
      email
      isSuppressed
      reason
    }
  }
`);

const useGetEmailSuppressionResults = (
  emails: string[],
  options?: Omit<
    UseQueryOptions<GetEmailSuppressionResultsQuery>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    ...options,
    queryKey: emailKeys.emailSuppressionResults(emails),
    queryFn: () => {
      return gqlClient.request(GET_EMAIL_SUPPRESSION_RESULTS, { emails });
    },
    enabled:
      options?.enabled !== undefined ? options.enabled : emails.length > 0,
  });
};

export const useEmailSuppressionResult = (email?: string | null) => {
  const { data: emailSuppressionResults } = useGetEmailSuppressionResults(
    email ? [email] : [],
    {
      enabled: !!email,
    }
  );

  if (!email || !emailSuppressionResults?.emailSuppressionResults) {
    return;
  }

  const suppressionResult =
    emailSuppressionResults.emailSuppressionResults.find(
      (result) => result.email === email
    );

  return suppressionResult;
};
